import { DataBean } from "../DataBean";

export class ImportedDataConstantsList extends DataBean {



    public async getPayrollImportedDataConstantsList(id: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getPayrollImportedDataConstantsList_Number", [id]);
    }

}
